import { Button, Card, Container, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";

interface LotErrorPageProps {
    title?: string | undefined;
    message?: string | undefined;
}

function LotErrorPage({ title = undefined, message = undefined }: LotErrorPageProps) {
    const { lotNumber } = useParams<{ lotNumber: string; }>();
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Container>
            <Card bg='light' className='rounded-3 mb-3'>
                <Card.Body>
                    <Stack className='mx-auto my-5'>
                        <h3 className='d-flex justify-content-center'>{title ?? t('LotDetails.ErrorPage.Title', { lotNumber: lotNumber })}</h3>
                        {message &&
                            <span className='text-muted d-flex justify-content-center'>{message}</span>
                        }
                        <div className='d-flex justify-content-center mt-3'>
                            <Button className='mx-1' onClick={() => navigate(-1)}>{t('LotDetails.ErrorPage.BackButton')}</Button>
                            <Button className='mx-1' onClick={() => navigate('/lots', { replace: true })}>{t('LotDetails.ErrorPage.HomeButton')}</Button>
                        </div>
                    </Stack>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default LotErrorPage;